// import React, { useState } from "react";
// import AdminSidebar from "./AdminSidebar";
// import AdminHeader from "./AdminHeader";
// import { Outlet } from "react-router-dom";
// import MobileBottomNav from "../Common/MobileBottomNav";
// import { useLocation } from "react-router-dom";
// import { useAdminContext } from "./AdminContext";

// const AdminLayout = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const [isShowSwitch, setIsShowSwitch] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   // const [selectedProductStore, setSelectedSProductStore] = useState(null);
//   // const [showSummary, setShowSummary] = useState(false);
//   // const [showCatalogue, setShowCatalogue] = useState(false);
//   // const [pinModelOpen, setPinModelOpen] = useState(false);
//   // const [orderModel, setOrderModel] = useState(false);
//   // const [customerStoreOwnerData, setCustomerStoreOwnerData] = useState("");
//   // const [pinData, setPinData] = useState("");
//   // const [updateModel, setUpdateModel] = useState(false);
//   // const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);

//   const {
//     selectedProductStore,
//     setSelectedSProductStore,
//     showSummary,
//     setShowSummary,
//     showCatalogue,
//     setShowCatalogue,
//     pinModelOpen,
//     setPinModelOpen,
//     orderModel,
//     setOrderModel,
//     customerStoreOwnerData,
//     setCustomerStoreOwnerData,
//     pinData,
//     setPinData,
//     updateModel,
//     setUpdateModel,
//     isModalDeleteOpen,
//     setIsModalDeleteOpen,
//     setCartData,
//     cartData,
//   } = useAdminContext();

//   const location = useLocation();
//   // const hideMobileNavRoutes = [
//   //   "/customer-store",
//   //   "/success",
//   //   "/setPin",
//   //   "/order-store-owner",
//   //   "/daily-collection",
//   // ];

//   // / Compute this first!
//   // const shouldHideMobileNav = hideMobileNavRoutes.includes(location.pathname);

//   const hideMobileNavRoutes = [
//     "/daily-collection",
//     "/order-store-owner",
//     "/success",
//     "/order-details",
//     "/all-store-owner-order-details",
//     "/update-profile-customer",
//     "/update-profile-store-owner",
//     "/update-store",
//     "/add-store",
//     "/products-add",
//     "/products-update",
//   ];

//   const isRouteOrderHidden = [
//     "/order-details",
//     "/all-store-owner-order-details",
//   ].some((route) => location.pathname.startsWith(route));

//   const isAppBackButtonVisible = () => {
//     return (
//       pinModelOpen ||
//       (selectedProductStore && (showSummary || showCatalogue)) ||
//       location.pathname.startsWith("/order-store-owner") ||
//       location.pathname.startsWith("/daily-collection") ||
//       isRouteOrderHidden ||
//       shouldNavigate ||
//       location.pathname.startsWith("/update-profile-customer") ||
//       location.pathname.startsWith("/update-profile-store-owner") ||
//       location.pathname.startsWith("/add-store") ||
//       location.pathname.startsWith("/update-store") ||
//       location.pathname.startsWith("/products-add") ||
//       location.pathname.startsWith("/products-update")
//     );
//   };

//   const isStoreListVisible =
//     !pinModelOpen && (!selectedProductStore || !showCatalogue);

//   // Should mobile nav hide due to route
//   const isRouteHidden = hideMobileNavRoutes.some((route) =>
//     location.pathname.startsWith(route),
//   );

//   // Final decision
//   const shouldShowMobileNav =
//     !isMobileMenuOpen && isStoreListVisible && !isRouteHidden;

//   return (
//     <div
//       className={`flex h-screen bg-[#F8F9FA] dark:bg-slate-950 overflow-hidden font-sans transition-colors duration-300 ${
//         isShowSwitch ? "pointer-events-none" : "pointer-events-auto"
//       }`}
//     >
//       <div className="hidden md:block">
//         <AdminSidebar isSidebarOpen={isSidebarOpen} />
//       </div>
//       <div className="flex-1 flex flex-col min-w-0 h-full">
//         <AdminHeader
//           setIsSidebarOpen={setIsSidebarOpen}
//           isSidebarOpen={isSidebarOpen}
//           setIsShowSwitch={setIsShowSwitch}
//           isShowSwitch={isShowSwitch}
//           isMobileMenuOpen={isMobileMenuOpen}
//           setIsMobileMenuOpen={setIsMobileMenuOpen}
//           selectedProductStore={selectedProductStore}
//           setSelectedSProductStore={setSelectedSProductStore}
//           showSummary={showSummary}
//           setShowSummary={setShowSummary}
//           showCatalogue={showCatalogue}
//           setShowCatalogue={setShowCatalogue}
//           setPinModelOpen={setPinModelOpen}
//           pinModelOpen={pinModelOpen}
//           setOrderModel={setOrderModel}
//           orderModel={orderModel}
//           setCustomerStoreOwnerData={setCustomerStoreOwnerData}
//           customerStoreOwnerData={customerStoreOwnerData}
//           setPinData={setPinData}
//           pinData={pinData}
//           setUpdateModel={setUpdateModel}
//           updateModel={updateModel}
//           setIsModalDeleteOpen={setIsModalDeleteOpen}
//           isModalDeleteOpen={isModalDeleteOpen}
//         />

//         <main className="flex-1 overflow-auto bg-brand-body dark:bg-slate-900/50 p-4 sm:p-6 lg:p-10 flex flex-col custom-scrollbar">
//           <div className="max-w-[1600px] mx-auto w-full flex-1 flex flex-col overflow-auto no-scrollbar">
//             <Outlet
//               context={{
//                 selectedProductStore,
//                 setSelectedSProductStore,
//                 setShowSummary,
//                 showSummary,
//                 setShowCatalogue,
//                 showCatalogue,
//                 setPinModelOpen,
//                 pinModelOpen,
//                 orderModel,
//                 setOrderModel,
//                 customerStoreOwnerData,
//                 setCustomerStoreOwnerData,
//                 pinData,
//                 setPinData,
//                 setUpdateModel,
//                 updateModel,
//                 isModalDeleteOpen,
//                 setIsModalDeleteOpen,
//                 setCartData,
//                 cartData,
//               }}
//             />
//           </div>
//         </main>
//       </div>
//       {shouldShowMobileNav && <MobileBottomNav />}{" "}
//     </div>
//   );
// };

// export default AdminLayout;

import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import MobileBottomNav from "../Common/MobileBottomNav";
import { useAdminContext } from "./AdminContext";

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isShowSwitch, setIsShowSwitch] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [pendingOrderList, setPendingOrderList] = useState(null);

  const {
    selectedProductStore,
    setSelectedSProductStore,
    showSummary,
    setShowSummary,
    showCatalogue,
    setShowCatalogue,
    pinModelOpen,
    setPinModelOpen,
    orderModel,
    setOrderModel,
    customerStoreOwnerData,
    setCustomerStoreOwnerData,
    pinData,
    setPinData,
    updateModel,
    setUpdateModel,
    isModalDeleteOpen,
    setIsModalDeleteOpen,
    setCartData,
    cartData,
    setStoreOwnerCart,
    storeOwnerCart,
    setIsModalCurrentPinDeleteOpen,
    isModalCurrentPinOpen
  } = useAdminContext();

  // Routes where mobile nav should be hidden
  const hideMobileNavRoutes = [
    "/daily-collection",
    "/order-store-owner",
    "/success",
    "/order-details",
    "/all-store-owner-order-details",
    "/update-profile-customer",
    "/update-profile-store-owner",
    "/update-store",
    "/add-store",
    "/products-add",
    "/products-update",
    "/owner-store-add",
    "/owner-store-update",
    "/change-password",
    "/pending-order",
    "/delete-account",
    "/wallet-store-details",
    "/wallet",
    "/product-chart",
    "/customer-report",
    "/fav-product"
  ];

  useEffect(() => {
    if (location.pathname === "/dashboard" || location.pathname === "/order") {
      setSelectedSProductStore(null);
      setShowSummary(false);
      setShowCatalogue(false);
      setPinModelOpen(false);
      setOrderModel(false);
      setCustomerStoreOwnerData("");
      setPinData("");
      setUpdateModel(false);
      setIsModalDeleteOpen(false);
      setCartData(null);
    }
  }, [location.pathname]);

  // Determine mobile nav visibility
  const isStoreListVisible =
    !pinModelOpen && (!selectedProductStore || !showCatalogue);
  const isRouteHidden = hideMobileNavRoutes.some((route) =>
    location.pathname.startsWith(route),
  );

  const isDashboardRoute = location.pathname === "/dashboard";

  const shouldShowMobileNav =
    !isMobileMenuOpen &&
    (isDashboardRoute || (isStoreListVisible && !isRouteHidden));

  return (
    <div
      className={`flex h-screen bg-[#F8F9FA] dark:bg-slate-950 overflow-hidden font-sans transition-colors duration-300 ${
        isShowSwitch ? "pointer-events-none" : "pointer-events-auto"
      }`}
    >
      {/* Sidebar */}
      <div className="hidden md:block">
        <AdminSidebar
          isSidebarOpen={isSidebarOpen}
          setStoreOwnerCart={setStoreOwnerCart}
        />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 h-full">
        <AdminHeader
          setIsSidebarOpen={setIsSidebarOpen}
          isSidebarOpen={isSidebarOpen}
          setIsShowSwitch={setIsShowSwitch}
          isShowSwitch={isShowSwitch}
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          selectedProductStore={selectedProductStore}
          setSelectedSProductStore={setSelectedSProductStore}
          showSummary={showSummary}
          setShowSummary={setShowSummary}
          showCatalogue={showCatalogue}
          setShowCatalogue={setShowCatalogue}
          setPinModelOpen={setPinModelOpen}
          pinModelOpen={pinModelOpen}
          setOrderModel={setOrderModel}
          orderModel={orderModel}
          setCustomerStoreOwnerData={setCustomerStoreOwnerData}
          customerStoreOwnerData={customerStoreOwnerData}
          setPinData={setPinData}
          pinData={pinData}
          setUpdateModel={setUpdateModel}
          updateModel={updateModel}
          setIsModalDeleteOpen={setIsModalDeleteOpen}
          isModalDeleteOpen={isModalDeleteOpen}
          setStoreOwnerCart={setStoreOwnerCart}
          storeOwnerCart={storeOwnerCart}
          setPendingOrderList={setPendingOrderList}
          pendingOrderList={pendingOrderList}
          setIsModalCurrentPinDeleteOpen={setIsModalCurrentPinDeleteOpen}
          isModalCurrentPinOpen={isModalCurrentPinOpen}
        />

        <main className="flex-1 overflow-auto bg-brand-body dark:bg-slate-900/50 p-4 sm:p-6 lg:p-10 flex flex-col custom-scrollbar">
          <div className="max-w-[1600px] mx-auto w-full flex-1 flex flex-col overflow-auto no-scrollbar">
            <Outlet
              context={{
                selectedProductStore,
                setSelectedSProductStore,
                setShowSummary,
                showSummary,
                setShowCatalogue,
                showCatalogue,
                setPinModelOpen,
                pinModelOpen,
                orderModel,
                setOrderModel,
                customerStoreOwnerData,
                setCustomerStoreOwnerData,
                pinData,
                setPinData,
                setUpdateModel,
                updateModel,
                isModalDeleteOpen,
                setIsModalDeleteOpen,
                setCartData,
                cartData,
                setStoreOwnerCart,
                storeOwnerCart,
                setPendingOrderList,
                pendingOrderList,
                setIsModalCurrentPinDeleteOpen,
                isModalCurrentPinOpen,
              }}
            />
          </div>
        </main>
      </div>

      {/* Mobile Bottom Nav */}
      {shouldShowMobileNav && <MobileBottomNav />}
    </div>
  );
};

export default AdminLayout;
